var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Menu',{attrs:{"orderTypeSelected":_vm.orderTypeSelected,"fee":_vm.feeOrder,"deliveryPaymentType":_vm.establishmentDeliveryPaymentType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }